// Types
import { artistSchema, artistListSchema } from 'modules/artists/models'
import { APIAction } from 'types'

// Utils
import { parseQueryForSearch } from 'modules/browse/actions'

export const actions = {
  fetchArtistInfo: (artistSlug: string): APIAction => ({
    CALL_API: {
      type: 'FETCH_ARTIST_INFO',
      method: 'GET',
      endpoint: `/api/artist/${artistSlug}/`,
      requestKey: artistSlug,
      schema: artistSchema,
    },
  }),
  fetchArtists: (queryString: string, page = 1): APIAction => {
    const parsedQueryString = parseQueryForSearch(queryString, page)
    return {
      CALL_API: {
        type: 'FETCH_ARTISTS',
        method: 'GET',
        endpoint: `/api/artist?${parsedQueryString}`,
        requestKey: queryString,
        schema: artistListSchema,
        actionParams: { page, queryString },
      },
    }
  },
}
